import { useId, useRef, useState } from "react";
import { Archive, ArchiveRestore, MoreHorizontal, Trash2 } from "lucide-react";
import type { DraftSummary } from "../shared/agent-drafts";

export type LifecycleAction = "archive" | "restore" | "delete";

export function ConversationMenu({
  conversation,
  disabled,
  act,
}: {
  conversation: DraftSummary;
  disabled: boolean;
  act: (action: LifecycleAction) => void;
}) {
  const id = useId();
  const popover = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  return (
    <div className="agent-conversation-menu">
      <button
        popoverTarget={id}
        aria-label={`Manage ${conversation.title}`}
        title="Manage conversation"
        onClick={(e) => {
          const bounds = e.currentTarget.getBoundingClientRect();
          setPosition({
            top: Math.min(bounds.bottom + 4, window.innerHeight - 130),
            left: Math.max(8, bounds.right - 220),
          });
        }}
      >
        <MoreHorizontal size={16} />
      </button>
      <div
        id={id}
        ref={popover}
        popover="auto"
        className="agent-conversation-popover"
        style={position}
      >
        <button
          disabled={disabled || conversation.status === "working"}
          onClick={() => {
            popover.current?.hidePopover();
            act(conversation.archivedAt ? "restore" : "archive");
          }}
        >
          {conversation.archivedAt ? (
            <ArchiveRestore size={14} />
          ) : (
            <Archive size={14} />
          )}
          {conversation.archivedAt
            ? "Restore conversation"
            : "Archive conversation"}
        </button>
        <button
          disabled={disabled || conversation.status === "working"}
          onClick={() => {
            popover.current?.hidePopover();
            act("delete");
          }}
        >
          <Trash2 size={14} /> Delete conversation…
        </button>
        {conversation.status === "working" && (
          <small>Stop the agent first.</small>
        )}
      </div>
    </div>
  );
}
